<template>
  <div id="app" class="app">
    <div class="app-layout app-layout-has-slider gx-app-layout">
      <b-loading
        style="z-index: 100;"
        :is-full-page="true"
        :active="screenLoading"
        :can-cancel="false"
      >
        <div class="loading-container">
          <div class="loading">
            <p>loading</p>
            <span></span>
          </div>
        </div>
      </b-loading>
      <div
        v-if="
          $route.name !== 'login' &&
            $route.name !== 'pageNotFound' &&
            $route.name !== 'coming-soon'
        "
        class="gx-app-sidebar app-layout-sidebar"
        v-bind:class="{ iconMenu: !this.isOpen }"
      >
        <div>
          <div class="menu-collapse-toggle">
            <i
              @click="toggleMenu"
              v-bind:class="{
                'mdi mdi-arrow-left-bold-box': this.isOpen,
                'mdi mdi-arrow-right-bold-box': !this.isOpen
              }"
            ></i>
          </div>

          <aside-menu :menu="menu" />
        </div>
      </div>
      <div class="app-layout">
        <div
          class="app-layout-nav"
          v-if="
            $route.name !== 'login' &&
              $route.name !== 'pageNotFound' &&
              $route.name !== 'coming-soon'
          "
        >
          <nav-bar />
        </div>
        <div class="app-layout-content gx-app-content">
          <div class="gx-main-content-wrapper">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/scss/main.scss";
</style>
<script>
/* eslint-disable no-console */
import NavBar from "@/modules/global/layouts/NavbarLayout.vue";
import AsideMenuLayout from "@/modules/global/layouts/AsideMenuLayout.vue";
//import FooterBar from "@/components/FooterBar";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    /*FooterBar,*/
    AsideMenu: AsideMenuLayout,
    NavBar
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.loginStore.isAuthenticated,
      // isInternal: state => state.globalStore ? state.globalStore.settings.isInternal : false,
      activeParams: state => state.globalStore.activeFilterParams
    }),
    ...mapGetters({
      screenLoading: "screenLoading",
      isInternal: "globalStore/isInternal"
    }),
    menu() {
      let list;
      if (this.isInternal) {
        list = [
          {
            to: "/dashboard",
            icon: "desktop-mac",
            label: "Dashboard"
          },
          {
            to: "/users",
            icon: "desktop-mac",
            label: "Edit Users"
          },
          {
            to: "/addUsers",
            label: "Add Learner",
            icon: "user",
            updateMark: false
          },
          {
            to: "/internal-tools",
            icon: "user",
            label: "Internal Tools"
          },
          {
            to: "/login",
            label: "Log out",
            icon: "table",
            updateMark: false
          }
        ];
      } else {
        list = [
          {
            to: "/dashboard",
            icon: "desktop-mac",
            label: "Dashboard"
          },
          {
            to: "/login",
            label: "Log out",
            icon: "table",
            updateMark: false
          }
        ];
      }

      return list;
    }
  },
  data() {
    return {
      isOpen: true
    };
  },
  methods: {
    ...mapActions({
      loading: "SET_SCREEN_LOADING"
    }),
    toggleMenu() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style>
html {
  overflow-y: auto;
}
</style>
